import { useQuery } from '@tanstack/react-query';
import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { checkInventoryExist } from './service';
import { EndpointQueryKeys } from '../constants/endpoints';

export const useInventoryCheck = (api: ApiClient, artEventId: string) => {
  return useQuery({
    queryKey: [EndpointQueryKeys.CHECK_INVENTORY_EXIST, artEventId],
    queryFn: () => checkInventoryExist(api, artEventId),
    enabled: !!artEventId,
    retry: false,
  });
};
